/* global workforceEnabledForEvent urlTotalheadcount urlCashFlowData chartUrl urlApiVenue eventStartDate eventEndDate urlProfitAndLoss */

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Notification } from 'rsuite';

import CashFlowChart from './CashflowChart';
import PieChart from './PieChart';
import TotalheadcountChart from './TotalheadcountChart';
import VenuesChart from './VenuesChart';

import { apiClient } from 'Helpers/network';

import 'react-tabs/style/react-tabs.css';
import './style.css';

function groupBy(arr, property) {
    return arr.reduce(function (memo, x) {
        if (!memo[x[property]]) {
            memo[x[property]] = [];
        }
        memo[x[property]].push(x);
        return memo;
    }, {});
}

const EventChart = (props) => {
    const [latestData, setLatestData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [cashflowData, setCashflowData] = useState();
    const [venueData, setVenueData] = useState();
    const [headcountData, setHeadcountData] = useState();

    const handler = (startDate, endDate, type) => {
        if (type === 'cashflow') {
            startDate = startDate.split('-');
            startDate = `${startDate[1]}-${startDate[0]}`;

            endDate = endDate.split('-');
            endDate = `${endDate[1]}-${endDate[0]}`;

            if (startDate === endDate) {
                Notification['error']({
                    title: 'Error',
                    description: <h6>You must choose at least 2 months</h6>,
                });
                return;
            }

            fetchData(startDate, endDate);
        } else if (type === 'headcount') {
            startDate = startDate.split('-');
            const beginDate = new Date(startDate[1], startDate[0]);
            const beginMonth = String(beginDate.getMonth()).padStart(2, '0');
            const beginDay = String(beginDate.getDate()).padStart(2, '0');
            const beginYear = beginDate.getFullYear();

            startDate = `${beginDay}-${beginMonth}-${beginYear}`;

            endDate = endDate.split('-');
            const lastDate = new Date(endDate[1], endDate[0]);
            const lastMonth = String(lastDate.getMonth()).padStart(2, '0');
            const lastDay = String(lastDate.getDate()).padStart(2, '0');
            const lastYear = lastDate.getFullYear();

            endDate = `${lastDay}-${lastMonth}-${lastYear}`;

            fetchHeadcountData(startDate, endDate, false);
        }
    };

    const fetchHeadcountData = (startDate, endDate, firstTime = true) => {
        const params = {
            start_date: startDate,
            end_date: endDate,
        };

        apiClient
            .get(urlTotalheadcount, { params })
            .then(({ data }) => {
                setHeadcountData(data.data);

                if (firstTime) {
                    return;
                }
                if (data.recordsTotal > 0) {
                    Notification['success']({
                        title: 'Success',
                        description: (
                            <h6>
                                Successfully pulled all the data between {startDate} - {endDate}
                            </h6>
                        ),
                    });
                } else {
                    Notification['error']({
                        title: 'Error',
                        description: <h6>There is no data during this period</h6>,
                    });
                }
            })
            .catch((err) => {
                setHeadcountData({ error: true });

                if (firstTime) {
                    return;
                }
                Notification['error']({
                    title: 'Error while retrieving data',
                    description: <h6>There is a server error. See the console.</h6>,
                });
            });
    };
    const fetchData = () => {
        axios
            .get(urlCashFlowData)
            .then((response) => {
                setCashflowData(response.data.chartData);
            })
            .catch((e) => {
                setCashflowData(undefined);
                console.log(e);
            });
    };

    useEffect(() => {
        fetchData();

        apiClient.get(chartUrl).then(({ data }) => {
            setLatestData(data);
            setChartData(groupBy(data, 'type'));
        });

        apiClient.get(urlApiVenue).then(({ data }) => {
            setVenueData(data);
        });

        fetchHeadcountData(eventStartDate, eventEndDate);
    }, []);
    return (
        <div className="chart_style row mb-3 g-4 mx-n2">
            {latestData !== undefined && (
                <>
                    {Object.keys(chartData).map((e, i) => {
                        return (
                            <div key={i} className="chart_style col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 px-2">
                                <div className="chart_style card bg-white border-0 rounded-15px shadow" style={{ maxHeight: '270px', minHeight: '270px' }}>
                                    <div className="chart_style card-body">
                                        <PieChart latestData={chartData[e]} index={i} name={i === 0 ? 'Revenues' : i === 2 ? 'Sales' : 'Expenditures'} />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </>
            )}
            {cashflowData !== undefined && (
                <div className="chart_style col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 px-2 mt-xl-0 mt-lg-4">
                    <div className="chart_style card bg-white border-0 rounded-15px shadow" style={{ maxHeight: '270px', minHeight: '270px', zIndex: 1 }}>
                        <div className="chart_style card-body">
                            <CashFlowChart data={cashflowData} />
                        </div>
                    </div>
                </div>
            )}
            {venueData !== undefined && (
                <div className="chart_style col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 px-2 mt-xl-0 mt-lg-4 mt-xl-4">
                    <div className="chart_style card bg-white border-0 rounded-15px shadow" style={{ maxHeight: '270px', minHeight: '270px', zIndex: 1 }}>
                        <div className="chart_style card-body">
                            <VenuesChart data={venueData} urlProfitAndLoss={urlProfitAndLoss} />
                        </div>
                    </div>
                </div>
            )}
            {headcountData !== undefined && !!props.workforceEnabledForEvent && (
                <div className="chart_style col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 px-2 mt-xl-0 mt-lg-4 mt-xl-4">
                    <div className="chart_style card bg-white border-0 rounded-15px shadow" style={{ maxHeight: '270px', minHeight: '270px', zIndex: 1 }}>
                        <div className="chart_style card-body">
                            <TotalheadcountChart data={headcountData} action={handler} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventChart;
if (document.getElementById('eventCharts')) {
    $(document).ready(function () {
        const rootEl = document.getElementById('eventCharts'); // data attributes below help us
        ReactDOM.render(
            <App>
                <EventChart workforceEnabledForEvent={workforceEnabledForEvent} />
            </App>,
            rootEl,
        );
        $(document).on('click.bs.dropdown.data-api', '.keep-open', function (e) {
            e.stopPropagation();
        });
    });
}
